import { render, staticRenderFns } from "./AchievementEmpty.vue?vue&type=template&id=1b30f56c&scoped=true&"
import script from "./AchievementEmpty.vue?vue&type=script&lang=js&"
export * from "./AchievementEmpty.vue?vue&type=script&lang=js&"
import style0 from "./AchievementEmpty.vue?vue&type=style&index=0&id=1b30f56c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b30f56c",
  null
  
)

export default component.exports